/**
 * Protected Route Component
 *
 * Protège les routes qui nécessitent une authentification
 */

import { Navigate } from 'react-router-dom';
import { isAuthenticated } from 'services/authServiceAPI';

const ProtectedRoute = ({ children }) => {
  console.log('🔍 ProtectedRoute: Vérification de l\'authentification...');

  // Debug: afficher le localStorage
  console.log('📦 LocalStorage tokens:', {
    localToken: localStorage.getItem('mongo.auth.token'),
    sessionToken: sessionStorage.getItem('mongo.auth.token'),
    userData: localStorage.getItem('user.data')
  });

  const authenticated = isAuthenticated();

  console.log('🔍 Résultat isAuthenticated():', authenticated);

  if (!authenticated) {
    console.log('🚫 Utilisateur non authentifié, redirection vers /authentication/sign-in');
    return <Navigate to="/authentication/sign-in" replace />;
  }

  console.log('✅ Utilisateur authentifié, accès autorisé');
  return children;
};

export default ProtectedRoute;
